module.exports = __webpack_public_path__ + "static/media/insu-april.6d112cfb.svg";